// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"reasons-module--wrapper--Kn61d","item":"reasons-module--item--2XZc0","title":"reasons-module--title--1KuMR h4"};